import { gql } from '@apollo/client';

export * from './createShareFileIntegration.mutation.generated';

export const CREATE_SHARE_FILE_INTEGRATION = gql`
  mutation createShareFileIntegration($shareFileIntegrationInput: ShareFileIntegrationInputAttributes!) {
    createShareFileIntegration(input: { shareFileIntegrationInput: $shareFileIntegrationInput }) {
      success
      errors
      shareFileIntegration {
        provider
        id
      }
    }
  }
`;
